import { EasyModal, Popover } from '@ui';
import React, { FC, useState } from 'react';

import { toast } from 'react-toastify';

import { PopoverMenuItem } from '../ui/popover/popover.type';

import ImportContent from './blocks/import-content';

type ImportAndExportButtonPropsType = {
  exportModalContent: React.ReactElement<{
    setExportModalState: React.Dispatch<React.SetStateAction<boolean>>;
  }>;
  labels: {
    importModal: string;
    exportModal: string;
    popoverLabel: string;
    toast_success: string;
    toast_error: string;
  };
  popoverItems: PopoverMenuItem[];
  importHandlerPromise: any;
};

const ImportAndExportButton: FC<ImportAndExportButtonPropsType> = (props) => {
  const { exportModalContent, labels, popoverItems, importHandlerPromise } = props;
  const [exportModal, setExportModalState] = useState(false);
  const [importModal, setImportModalState] = useState(false);
  // const ImportModalComponent = React.cloneElement(importModalContent, { setImportModalState });
  const ExportModalComponent = React.cloneElement(exportModalContent, { setExportModalState });

  function clickActionsDropdown(key: string) {
    if (key === 'export') {
      setExportModalState(true);
    } else {
      setImportModalState(true);
    }
  }

  function importHandler(result) {
    importHandlerPromise({ body: result })
      .unwrap()
      .then(() => toast.success(labels.toast_success))
      .catch(() => toast.error(labels.toast_error))
      .finally(() => setImportModalState?.(false));
  }

  return (
    <>
      <Popover
        size={270}
        label={labels.popoverLabel}
        menu={popoverItems}
        position="end"
        onClick={(key) => clickActionsDropdown(key)}
      />
      <EasyModal
        withoutFooter
        label={labels.importModal}
        show={importModal}
        onClose={() => setImportModalState(false)}
      >
        {importModal && (
          <ImportContent onImportFile={importHandler} setImportModalState={setImportModalState} />
        )}
      </EasyModal>
      <EasyModal
        withoutFooter
        label={labels.exportModal}
        show={exportModal}
        onClose={() => setExportModalState(false)}
      >
        {exportModal && ExportModalComponent}
      </EasyModal>
    </>
  );
};

export default ImportAndExportButton;
